import { useState } from 'react'

import { toast } from 'react-toastify'
import { Form, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import { CloudArrowDownFill, Search } from 'react-bootstrap-icons'

import Navbar from '../../components/navbar/navbar'
import { CustomButton } from '../../components/CustomButton'

import apinode from '../../services/apinode'
import BlingService from '../../services/database/BlingService'

import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

import { Center, Container } from './styles'

export function ImportarProdutosBling() {
  const [search, setSearch] = useState('')
  const [previousSearch, setPreviousSearch] = useState('')
  const [product, setProduct] = useState({})

  const [isRequestSearchLoading, setIsRequestSearchLoading] = useState(false)
  const [isRequestImportLoading, setIsRequestImportLoading] = useState(false)

  async function handleSearchProductBling() {
    console.log({ search, previousSearch })

    if (search !== previousSearch) {
      try {
        setIsRequestSearchLoading(true)

        const { data } = await BlingService.getProductBySku(search)

        if (!data) {
          setPreviousSearch('')
          setProduct({})

          return toast.error('Produto não encontrado no Bling!')
        }

        setPreviousSearch(search)
        setProduct(data)
      } catch (err) {
        sendErrorApiMessage(err, 'Não foi possível encontrar o produto!')
      } finally {
        setSearch('')
        setIsRequestSearchLoading(false)
      }
    }
  }

  async function handleImportProductBling(productSku) {
    try {
      setIsRequestImportLoading(true)

      const response = await apinode.get(
        `/bling/importProduct/${productSku}/${localStorage.idconta}`,
      )

      const codProduto = response.data.codProduto

      toast.success(`Produto importado com sucesso com o ID: ${codProduto}`)
      setSearch('')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível importar o produto!')
    } finally {
      setIsRequestImportLoading(false)
    }
  }

  return (
    <>
      <Navbar />

      <Container className="mt-page">
        <h1>Importar Produtos do Bling</h1>

        <Center>
          <Form.Control
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Digite o SKU do produto"
            style={{
              width: '100%',
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                if (e.target.value.length > 0) {
                  handleSearchProductBling()
                }
              }
            }}
          />

          <CustomButton
            title="Pesquisar"
            isDisabled={!search}
            color="#0059ff"
            onClick={handleSearchProductBling}
            isLoading={isRequestSearchLoading}
            isLoadingText="Pesquisando..."
          >
            <Search />
          </CustomButton>
        </Center>

        {product?.codigo && (
          <Table>
            <thead>
              <tr>
                <th>SKU</th>
                <th>Descrição</th>
                <th>Preço</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{product?.codigo}</td>
                <td>{product?.nome}</td>
                <td>{product?.preco}</td>
                <td>
                  <OverlayTrigger overlay={<Tooltip>Importar</Tooltip>}>
                    <CustomButton
                      onClick={() => handleImportProductBling(product?.codigo)}
                      isLoading={isRequestImportLoading}
                    >
                      <CloudArrowDownFill />
                    </CustomButton>
                  </OverlayTrigger>
                </td>
              </tr>
            </tbody>
          </Table>
        )}
      </Container>
    </>
  )
}
